// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (-webkit-min-device-pixel-ratio: 0) {
  .body {
    margin: 0;
    font-family: Arial, Helvetica, sans-serif;
  }

  .app {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }

  .main-content {
    /* flex: 1; */
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    max-width: 100%;
    box-sizing: border-box;
  }

  .content {
    flex: 1 1;
    margin-left: 220px;
    /* Space for side nav */
    padding: 0.3125rem;
    /* 5px converted to rem */
    width: calc(100% - 220px);
    overflow-y: auto;
    overflow-x: hidden;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    box-sizing: border-box;
    max-width: calc(100% - 220px);
  }

  .content.full-width {
    margin-left: 0.625rem;
    /* 10px converted to rem */
    width: calc(100% - 0.625rem);
    max-width: calc(100% - 0.625rem);
    animation: fadeIn 0.4s ease-in-out;
    box-sizing: border-box;
    overflow-x: hidden;
  }

  /* Ensure tables are responsive when sidebar is toggled */
  .content.full-width .table-container,
  .content.full-width saf-table,
  .content.full-width .mytable {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
  }

  /* Footer transitions are now handled in footer.css */
  .custom-footer {
    transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1), margin-left 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .custom-footer.full-width {
    width: calc(100% - 0.625rem);
    margin-left: 0.625rem;
  }

  @keyframes fadeIn {
    from {
      opacity: 0.8;
      transform: translateX(-10px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  /* Toggle button styling */

  .toggle-btn {
    position: fixed;
    top: 50px;
    left: 210px;
    z-index: 1002;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: left 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    transform: scale(1);
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
  }

  .toggle-btn.sidebar-hidden {
    transition: all 0s cubic-bezier(0, 0, 0, 0);
    left: 0;
  }

  .toggle-btn:hover {
    background: #f8f9fa;
    box-shadow: 0 4px 12px rgba(214, 64, 0, 0.15);
    transform: scale(1.05);
  }

  .toggle-btn:active {
    transform: scale(0.95);
  }

  .arrow-icon {
    font-size: 16px;
    color: #666;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    display: inline-block;
  }

  .toggle-btn:hover .arrow-icon {
    color: #d64000;
  }

  .arrow-icon.left {
    transform: translateX(0);
  }

  .arrow-icon.right {
    transform: translateX(0);
  }

  saf-table th {
    --saf-table-th-background: #d5e0e8;
    --saf-table-th-width: 12.5rem;
    --saf-table-td-font: 0.8125rem;
  }

  body.sidebar-hidden .header-container .cloud-permit-header {
    max-width: calc(100% - 20px) !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE;IACE,SAAS;IACT,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,iDAAiD;IACjD,kBAAkB;IAClB,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,4BAA4B;IAC5B,gCAAgC;IAChC,kCAAkC;IAClC,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,yDAAyD;EACzD;;;IAGE,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA,qDAAqD;EACrD;IACE,kGAAkG;EACpG;;EAEA;IACE,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;IACE;MACE,YAAY;MACZ,4BAA4B;IAC9B;;IAEA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA,0BAA0B;;EAE1B;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yCAAyC;IACzC,kDAAkD;IAClD,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,2CAA2C;IAC3C,OAAO;EACT;;EAEA;IACE,mBAAmB;IACnB,6CAA6C;IAC7C,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,iDAAiD;IACjD,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kCAAkC;IAClC,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,uCAAuC;EACzC;AACF","sourcesContent":["@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  .body {\n    margin: 0;\n    font-family: Arial, Helvetica, sans-serif;\n  }\n\n  .app {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n  }\n\n  .main-content {\n    /* flex: 1; */\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    overflow-x: hidden;\n    max-width: 100%;\n    box-sizing: border-box;\n  }\n\n  .content {\n    flex: 1;\n    margin-left: 220px;\n    /* Space for side nav */\n    padding: 0.3125rem;\n    /* 5px converted to rem */\n    width: calc(100% - 220px);\n    overflow-y: auto;\n    overflow-x: hidden;\n    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n    box-sizing: border-box;\n    max-width: calc(100% - 220px);\n  }\n\n  .content.full-width {\n    margin-left: 0.625rem;\n    /* 10px converted to rem */\n    width: calc(100% - 0.625rem);\n    max-width: calc(100% - 0.625rem);\n    animation: fadeIn 0.4s ease-in-out;\n    box-sizing: border-box;\n    overflow-x: hidden;\n  }\n\n  /* Ensure tables are responsive when sidebar is toggled */\n  .content.full-width .table-container,\n  .content.full-width saf-table,\n  .content.full-width .mytable {\n    width: 100% !important;\n    min-width: 100% !important;\n    max-width: 100% !important;\n  }\n\n  /* Footer transitions are now handled in footer.css */\n  .custom-footer {\n    transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1), margin-left 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n\n  .custom-footer.full-width {\n    width: calc(100% - 0.625rem);\n    margin-left: 0.625rem;\n  }\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0.8;\n      transform: translateX(-10px);\n    }\n\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  /* Toggle button styling */\n\n  .toggle-btn {\n    position: fixed;\n    top: 50px;\n    left: 210px;\n    z-index: 1002;\n    background: #fff;\n    border: 1px solid #eee;\n    border-radius: 50%;\n    width: 35px;\n    height: 35px;\n    cursor: pointer;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n    transition: left 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n    transform: scale(1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n  }\n\n  .toggle-btn.sidebar-hidden {\n    transition: all 0s cubic-bezier(0, 0, 0, 0);\n    left: 0;\n  }\n\n  .toggle-btn:hover {\n    background: #f8f9fa;\n    box-shadow: 0 4px 12px rgba(214, 64, 0, 0.15);\n    transform: scale(1.05);\n  }\n\n  .toggle-btn:active {\n    transform: scale(0.95);\n  }\n\n  .arrow-icon {\n    font-size: 16px;\n    color: #666;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    display: inline-block;\n  }\n\n  .toggle-btn:hover .arrow-icon {\n    color: #d64000;\n  }\n\n  .arrow-icon.left {\n    transform: translateX(0);\n  }\n\n  .arrow-icon.right {\n    transform: translateX(0);\n  }\n\n  saf-table th {\n    --saf-table-th-background: #d5e0e8;\n    --saf-table-th-width: 12.5rem;\n    --saf-table-td-font: 0.8125rem;\n  }\n\n  body.sidebar-hidden .header-container .cloud-permit-header {\n    max-width: calc(100% - 20px) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
